const apiBase = 'http://185.28.23.139:8080/roqui_palacios'
// const apiBase = 'http://127.0.0.1:8080'

const configService = {  
  apiAuth: apiBase.concat('/rest/v1/auth'),
  apiUrl: apiBase.concat('/rest/v1')
}

export default configService